module.exports = require("./pt-AO.d.ts");